<button
    type="button"
    nz-button
    nz-tooltip
    nzTooltipTitle="Apskatīt failu"
    nzType="info"
    aria-label="Apskatīt failu"
    (click)="open()"
>
    <span nz-icon nzType="search" nzTheme="outline"></span>
</button>
